import React from 'react';
import ColorScale from '_class/ColorScale';
import DisplayCell from './DisplayCell';

var DisplayGoal = function DisplayGoal(_ref) {
  var goal = _ref.goal,
      statistic = _ref.statistic;

  if (goal == null) {
    return null;
  }
  /**
   * @param {object} row
   */


  var getColors = function getColors(row) {
    var showRed = row.cells.find(function (cell) {
      return cell.type == 'NotAchievedTextField';
    }) != null;
    return new ColorScale(row.cells.length).get(showRed);
  };
  /**
   * @param {object} row
   * @param {number} index
   * @returns {object} assessmentDetail
   */


  var getCellAssessmentDetails = function getCellAssessmentDetails(row, index) {
    if (statistic == null) {
      return [];
    }

    var foundEntry = statistic.statistics.find(function (stat) {
      return stat.index == index;
    });

    if (foundEntry != null) {
      return foundEntry.assessmentDetails.filter(function (detail) {
        return detail.assessmentBlockPartRow.referenceId == row.id;
      });
    }

    return [];
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "block--assessment-block consume"
  }, /*#__PURE__*/React.createElement("div", {
    className: "display-matrix"
  }, goal.rows.map(function (row) {
    var _row$cells;

    var cells = (_row$cells = row.cells) === null || _row$cells === void 0 ? void 0 : _row$cells.sort(function (a, b) {
      return a.index - b.index;
    });
    var colors = getColors(row);
    return /*#__PURE__*/React.createElement("div", {
      className: "df row",
      key: row.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "column-text"
    }, row.description), /*#__PURE__*/React.createElement("div", {
      className: "cells df"
    }, cells.map(function (cell, index) {
      var assessmentDetails = getCellAssessmentDetails(row, index);
      return /*#__PURE__*/React.createElement(DisplayCell, {
        color: colors[index],
        cell: cell,
        key: cell.id,
        assessmentDetails: assessmentDetails
      });
    })));
  })));
};

export default DisplayGoal;